import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import PDCategoryView from "../components/PDCategoryView"
import SecondaryManual from "../images/secondary-manual.jpg"
import PowerpointLogo from "../images/powerpoint-icon.svg"
import PDFLogo from "../images/pdf.svg"

class SecondaryDevelopment extends React.Component {
  state = {
    view: {
      title: "Secondary Professional Development",
      parentURL: "/professional-development",
      parentName: "professional development",
      categories: [
        {
          name: "Training manual",
          file: SecondaryManual,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/secondary/secondary-manual.pdf",
        },
        {
          name: "Presentations",
          fileType: PowerpointLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/secondary/PPP/",
          files: [
            { name: "Expectations and Outcomes", file: "S1.1.1.pptx" },
            { name: "What is a seondary ELT teacher?", file: "S1.1.2.pptx" },
            { name: "Teacher Development Overview", file: "S1.1.3.pptx" },
            { name: "Teaching vs Training", file: "S1.1.4.pptx" },
            { name: "Guided self-discovery", file: "S1.2.1.pptx" },
            { name: "Material Overview", file: "S1.2.2.pptx" },
            { name: "Defining Objectives and Outcomes", file: "S1.2.3.pptx" },
            {
              name: "Determining the needs of your teachers",
              file: "S1.2.4.pptx",
            },
            {
              name: "Motivation and teenagers – the challenges",
              file: "S1.3.1.pptx",
            },
            {
              name: "Teenage motivation – classroom strategies",
              file: "S1.3.2.pptx",
            },
            { name: "Outcomes for your workshops", file: "S1.3.3.pptx" },
            {
              name: "An Overview of Training Methodology",
              file: "S1.3.4.pptx",
            },
            {
              name: "Approaches to Teaching Grammar at Secondary Level",
              file: "S1.4.1.pptx",
            },
            {
              name: "Grammar in 21st Century English for Libya",
              file: "S1.4.2.pptx",
            },
            {
              name: "Training Methodology – practice and evaluation",
              file: "S1.4.3.pptx",
            },
            { name: "The Training Life Cycle", file: "S1.4.4.pptx" },
            {
              name: "What are task-based learning and project work",
              file: "S1.5.1.pptx",
            },
            {
              name: "Applying Task and Project-Based Learning",
              file: "S1.5.2.pptx",
            },
            { name: "Agreeing on the Workshops", file: "S1.5.3.pptx" },
            { name: "Planning a Workshop", file: "S1.5.4.pptx" },
            {
              name: "Microteaching – introduction and preparation",
              file: "S1.6.1.pptx",
            },
            { name: "Microteaching 1", file: "S1.6.2.pptx" },
            { name: "Microtraining 1 – preparation", file: "S1.6.3.pptx" },
            {
              name: "Microtraining 1 – delivery and feedback",
              file: "S1.6.4.pptx",
            },
            { name: "What is reading?", file: "S2.1.1.pptx" },
            {
              name: "Approaches to Teaching Reading in 21st Century English for Libya",
              file: "S2.1.2.pptx",
            },
            { name: "Designing a Training Kit", file: "S2.1.3.pptx" },
            { name: "Four-day training. An overview.", file: "S2.1.4.pptx" },
            {
              name: "21st Century Skills – in and out of the classroom",
              file: "S2.2.1.pptx",
            },
            {
              name: "21st Century Skills – in secondary ELT",
              file: "S2.2.2.pptx",
            },
            { name: "Workshop Design and Evaluation", file: "S2.2.3.pptx" },
            {
              name: "Full-length workshop design and evaluation",
              file: "S2.2.4.pptx",
            },
            {
              name: "Teaching speaking and pronunication – key issues",
              file: "S2.3.1.pptx",
            },
            {
              name: "Speaking and Pronunciation in 21st Century English for Libya",
              file: "S2.3.2.pptx",
            },
            { name: "Microtraining 2 – preparation", file: "S2.3.3.pptx" },
            {
              name: "Microtraining 2 – delivery and feedback",
              file: "S2.3.4.pptx",
            },
            {
              name: "Microteaching 2 – collaborative preparation and discussion",
              file: "S2.4.1.pptx",
            },
            {
              name: "Microteaching 2 – delivery and feedback",
              file: "S2.4.2.pptx",
            },
            {
              name: "Methodology – key areas for improvement",
              file: "S2.4.3.pptx",
            },
            {
              name: "Strategies for changing teachers' approaches",
              file: "S2.4.4.pptx",
            },
            {
              name: "Listening – challenges and strategies",
              file: "S2.5.1.pptx",
            },
            {
              name: "Learning to Listen in 21st Century English for Libya",
              file: "S2.5.2.pptx",
            },
            { name: "Training Adult Teachers", file: "S2.5.3.pptx" },
            { name: "Strategies for Training Adults", file: "S2.5.4.pptx" },
            {
              name: "What are the challenges of assessing teenagers?",
              file: "S2.6.1.pptx",
            },
            {
              name: "Assessment and Examinations in practice",
              file: "S2.6.2.pptx",
            },
            {
              name: "The active and collaborative learning environment",
              file: "S2.6.3.pptx",
            },
            {
              name: "Evaluation, Reporting and Oral Feedback – process and language",
              file: "S2.6.4.pptx",
            },
            { name: "Adapting my approach", file: "S3.1.1.pptx" },
            {
              name: "Practical lesson planning and peer feedback",
              file: "S3.1.2.pptx",
            },
            { name: "Setting up Microtraining", file: "S3.1.3.pptx" },
            {
              name: "Self-Awareness and Reflective Practice",
              file: "S3.1.4.pptx",
            },
            {
              name: "Approaches to Writing for Teenagers",
              file: "S3.2.1.pptx",
            },
            {
              name: "How writing is taught in 21st Century English for Libya",
              file: "S3.2.2.pptx",
            },
            { name: "Microtraining 3 – preparation", file: "S3.2.3.pptx" },
            {
              name: "Microtraining 3 – delivery and feedback",
              file: "S3.2.4.pptx",
            },
            { name: "Large and Mixed-Ability Classes", file: "S3.3.1.pptx" },
            {
              name: "Using 21st Century English for Libya with large and/or mixed-ability classes",
              file: "S3.3.2.pptx",
            },
            { name: "Full workshop preparation", file: "S3.3.3.pptx" },
            { name: "Full workshop preparation", file: "S3.3.4.pptx" },
            {
              name: "Microtraining 3 – collaborative preparation and discussion",
              file: "S3.4.1.pptx",
            },
            {
              name: "Microteaching 3 – delivery and feedback",
              file: "S3.4.2.pptx",
            },
            { name: "Full workshop preparation", file: "S3.4.3.pptx" },
            { name: "Full workshop preparation", file: "S3.4.4.pptx" },
            { name: "Bringing it all together", file: "S3.5.1.pptx" },
            { name: "Presentations and Questions", file: "S3.5.2.pptx" },
            { name: "Poster presentations and display", file: "S3.5.3.pptx" },
          ],
        },
        {
          name: "Handouts",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/secondary/Handouts/",
          files: [
            {
              name: "Handout Lesson Observation",
              file: "Handout-Lesson-Observation.pdf",
            },
            {
              name: "Handout Peer Feedback Cards",
              file: "Handout-Peer-feedback.pdf",
            },
            { name: "Handout S2.1.4.1", file: "Handout-S2.1.4.1.pdf" },
            { name: "Handout S2.1.4.2", file: "Handout-S2.1.4.2.pdf" },
            { name: "Handout S2.2.1", file: "Handout-S2.2.1.pdf" },
            { name: "Handout S2.3.1.1", file: "Handout-S2.3.1.1.pdf" },
            { name: "Handout S2.3.1.2", file: "Handout-S2.3.1.2.pdf" },
            { name: "Handout S2.5.1", file: "Handout-S2.5.1.pdf" },
            { name: "Handout S2.5.3", file: "Handout-S2.5.3.pdf" },
            { name: "Handout S2.5.4.1", file: "Handout-S2.5.4.1.pdf" },
            { name: "Handout S2.5.4.2", file: "Handout-S2.5.4.2.pdf" },
            { name: "Handout S2.6.3", file: "Handout-S2.6.3.pdf" },
            { name: "Handout S3.1.2", file: "Handout-S3.1.2.pdf" },
            {
              name: "Handout Workshop Observations",
              file: "Handout-Workshop-Observations.pdf",
            },
          ],
        },
        {
          name: "Videos",
          embedPath: "https://player.vimeo.com/video/",
          files: [
            { title: "Assessment & Large classes", id: "291286804" },
            { title: "Classroom management", id: "291286824" },
            { title: "Defining objectives and outcomes", id: "291286840" },
            { title: "Determining needs of your teachers", id: "291286852" },
            { title: "Error correction", id: "291286867" },
            { title: "Expectations & Outcomes", id: "291286879" },
            { title: "Grammar and teaching grammar", id: "291286920" },
            {
              title: " Group session on book walkthrough + adults learners",
              id: "291286930",
            },
            {
              title: "Group Session on Introduction to the course",
              id: "291286943",
            },
            {
              title:
                "Group Session on Motivation and teenagers - the challenges",
              id: "291286959",
            },
            { title: "Group session on Teenage motivation", id: "291286995" },
            { title: "Lesson planning", id: "291287043" },
            { title: "Microtraining - Delivery and feedback", id: "291287074" },
            { title: "Presentations", id: "291287109" },
            {
              title: "Teacher development vs. Teacher training",
              id: "291287162",
            },
            { title: "Teaching writing", id: "291287220" },
            {
              title: "Vocabulary & Approaches to teaching vocabulary",
              id: "291287255",
            },
            {
              title: "Welcoming speech by Christopher Graham",
              id: "291287272",
            },
            {
              title: "Welcoming speech by Dr. Massouda El Aswad",
              id: "291287285",
            },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <PDCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default SecondaryDevelopment



// WEBPACK FOOTER //
// ./src/components/SecondaryProfessionalDevelopment.js